// extracted by mini-css-extract-plugin
export default {"portfolio":"App_portfolio__xPBds"};